import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[magicHover]',
})

/**
 * MagicHoverDirective est une directive qui crée un effet de survol
 * quand il est appliqué à un élément.
 * Cette effet peut être utilisé pour améliorer l'interaction utilisateur
 * 
 * description de l'effet de survol :
 * l'effet de survol ajoute une gradient de bruit  avec un dégradé de transparence
 * radial centré sur le curseur de la souris.
 * Il est activé par le mouvement de la souris et désactivé lorsque la souris quitte l'élément.

 */
export class MagicHoverDirective {
  private elementRef: ElementRef = inject(ElementRef);

  onMouseMove = (event: MouseEvent) => {
    const element: HTMLElement = this.elementRef.nativeElement;
    const x = event.clientX - element.getBoundingClientRect().left;
    const y = event.clientY - element.getBoundingClientRect().top;
    element.style.setProperty('--after-opacity', '1');
    element.style.setProperty('--mouse-x', `${x}px`);
    element.style.setProperty('--mouse-y', `${y}px`);
  };

  onMouseLeave = () => {
    const element: HTMLElement = this.elementRef.nativeElement;
    element.style.setProperty('--after-opacity', '0');
  };

  ngOnInit(): void {
    if (!this.elementRef || !this.elementRef.nativeElement) {
      throw new Error('Element not found');
    }
    const element: HTMLElement = this.elementRef.nativeElement;
    element.classList.add('magic-hover');
    element.addEventListener('mousemove', this.onMouseMove);
    element.addEventListener('mouseleave', this.onMouseLeave);
  }

  ngOnDestroy(): void {
    const element: HTMLElement = this.elementRef.nativeElement;
    element.removeEventListener('mousemove', this.onMouseMove);
    element.removeEventListener('mouseleave', this.onMouseLeave);
  }
}
